import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";
import { type WebPushSubscription, webPushSubscriptionSchema } from "@/schemas";

function usePushSubscription() {
  const api = useApi();
  const { currentAccount, isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ["web-push-subscriptions", currentAccount?.acct],
    queryFn: async () => {
      try {
        const { data } = await api.get<WebPushSubscription>(
          "/api/v1/push/subscription",
        );
        return webPushSubscriptionSchema.parse(data);
      } catch (e) {
        if (e instanceof AxiosError && e.response?.status === 404) {
          return null;
        } else {
          throw e;
        }
      }
    },
    enabled: isLoggedIn,
  });
}

export { usePushSubscription };
